//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        text: '',
        currency: [],
        type: [],
        createdFrom: '',
        createdTo: '',
      },
      constant,
    };
  },

  computed: {
    ...mapState('currencies', ['currencies']),
    ...mapState('merchantsInvoicesTransactions', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('merchantsInvoicesTransactions', ['setFilters']),
  },
};
